'use client';
import { useEffect, useState } from 'react';
import useHuddle01 from './useHuddle01';

export const useLobby = (props?: {
  onLobbyPeersUpdated?: (lobbyPeersIds: string[]) => void;
  onNewLobbyPeer?: (peer: {
    peerId: string;
    metadata?: string | undefined;
  }) => void;
}) => {
  const { huddleClient } = useHuddle01();

  const [lobbyPeersIds, setLobbyPeersIds] = useState<string[]>(
    huddleClient.room.lobbyPeerIds,
  );

  useEffect(() => {
    const room = huddleClient.room;

    const handleNewLobbyPeers = (lobbyPeerIds: string[]) => {
      setLobbyPeersIds(lobbyPeerIds);

      if (props?.onLobbyPeersUpdated) {
        props.onLobbyPeersUpdated(lobbyPeerIds);
      }
    };

    const handleNewLobbyPeer = (peer: {
      peerId: string;
      metadata?: string | undefined;
    }) => {
      if (props?.onNewLobbyPeer) {
        props.onNewLobbyPeer(peer);
      }
    };

    room.on('lobby-peers-updated', handleNewLobbyPeers);

    room.on('new-lobby-peer', handleNewLobbyPeer);

    return () => {
      room.off('lobby-peers-updated', handleNewLobbyPeers);

      room.off('new-lobby-peer', handleNewLobbyPeer);
    };
  }, []);

  const admitPeer = huddleClient.room.admitPeer;

  const denyPeer = huddleClient.room.denyPeer;

  const getLobbyPeerMetadata = huddleClient.room.getLobbyPeerMetadata;

  return { lobbyPeersIds, getLobbyPeerMetadata, admitPeer, denyPeer };
};
